import parse from "html-react-parser";
import { getProductFlex } from "config/productFlex";
import cloneDeep from "lodash.clonedeep";
import get from "lodash.get";
import {
  COLLECTION_SKU,
  SECTION_PATH,
  LANDING_STATUS_PATH,
} from "utils/shop-settings";
import { sortByProductsOrder } from "utils/product";

export function share(liff, shareText) {
  liff.openWindow({
    url: `https://line.me/R/msg/text/?${encodeURIComponent(shareText)}`,
    external: false,
  });
}

export async function shareStore({ liff, image }) {
  // if (!image) {
  //   const permanentLink = liff.permanentLink.createUrl();
  //   const shareText = `Georg Jensen正式官方帳號，點擊連結前往查看：${permanentLink}`;
  //   share(liff, shareText);
  // } else {
  //   const flex = getShareStoreFlex(image);
  //   try {
  //     await liff.shareTargetPicker([flex], { isMultiple: true });
  //   } catch (err) {
  //     const permanentLink = liff.permanentLink.createUrl();
  //     const shareText = `Georg Jensen正式官方帳號，點擊連結前往查看：${permanentLink}`;
  //     share(liff, shareText);
  //     console.log("image", image);
  //     console.log("flex", flex);
  //     console.log("something wrong happen", err);
  //   }
  // }
}

export async function shareProductFlex({ liff, product = {} }) {
  const flex = getProductFlex({ product });
  try {
    await liff.shareTargetPicker([flex], { isMultiple: true });
  } catch (err) {
    const permanentLink = liff.permanentLink.createUrl();
    const shareText = `『${product.name || ""}』\n${(
      product.description || ""
    ).slice(0, 30)}...\n點擊連結前往購買：${permanentLink}`;
    share(liff, shareText);

    console.error("something wrong happen", err);
  }
}

export const getTagDetail = (tagTitle = "") => {
  const [text, title, status] = tagTitle.split("_");
  return { text, title, status };
};

// export const getIsNewProduct = ({ shop, product = {}, productTags }) => {
//   const NEW_PRODUCT = get(shop, NEW_PRODUCT_TAG_PATH);

//   const newProductTag = productTags.find(({ title }) => title === NEW_PRODUCT);
//   return (
//     newProductTag &&
//     (product.tags || []).find(({ tagId }) => tagId === newProductTag.id)
//   );
// };

export const getImagesByTag = (images = [], tagTitle) => {
  // TODO: maybe it can fixed by image tag
  let titleInImgIdx = -1;
  return cloneDeep(images)
    .filter((img) => {
      const { title = "", desc = "" } = img;
      titleInImgIdx = title.split(",").findIndex((t) => t === tagTitle);
      if (titleInImgIdx !== -1) {
        img.title = tagTitle;
        img.desc = desc.split(",")[titleInImgIdx];
      }
      return titleInImgIdx !== -1;
    })
    .sort((a, b) => Number(a.desc) - Number(b.desc));
};

export const getCookie = (cookieKey) => {
  const cookies = document.cookie.split(";").reduce((acc, cookie) => {
    const [key, value] = cookie.split("=");
    acc[key] = value;
    return acc;
  }, {});
  return cookieKey ? cookies[cookieKey] : cookies;
};

export const setCookie = (cookieKey, expireTime) => {
  document.cookie = `${cookieKey}=true; expires=${expireTime}`;
};

export const getFullAddress = (addressInfo = {}) => {
  return [
    addressInfo["PostalCode"],
    addressInfo["Street Address"],
    addressInfo["Apt"],
    addressInfo["City"],
    addressInfo["Country"],
  ]
    .filter(Boolean)
    .join(", ");
};

export const getFullPhone = (phoneInfo = {}) => {
  return [phoneInfo["Country Code"], phoneInfo["Phone Number"]]
    .filter(Boolean)
    .join("");
};

export const getFullName = (nameInfo = {}) => {
  return [nameInfo["First Name"], nameInfo["Last Name"]]
    .filter(Boolean)
    .join(" ");
};

export const getTitle = (nameInfo = {}, myInfo = {}) => {
  const targetValue = myInfo["Title"];
  const result = nameInfo
    .filter((item) => item.sources)
    .flatMap((item) => item.sources)
    .find((source) => source.key === targetValue);

  return result?.label;
};

export function getHighLightedTag(tags = []) {
  return (
    tags.find(({ title }) => (title || "").startsWith("HIGHLIGHTED"))?.title ||
    ""
  )
    .replace("HIGHLIGHTED__", "")
    .replace("_", " ");
}

export function getCollectionTags(tags = []) {
  return tags.filter(({ title }) => title.startsWith("COLLECTION_"));
}

export function findFestivalTagIdBykey(shop, productTags, key) {
  //TODO:檢查是可以刪掉
  const sections = get(shop, SECTION_PATH, []);
  const collectionSku = sections.find(
    (section) => section.sectionType === COLLECTION_SKU
  );
  const TAG_TEXT = collectionSku.tagPrefix;
  const STATUS = get(shop, LANDING_STATUS_PATH, {});

  const tags = productTags.filter(
    ({ title }) => title.startsWith(TAG_TEXT) && title.endsWith(STATUS.ON)
  );

  return tags.find(({ title }) => title.split("_")[1] === key)?.id;
}

export function getI18nText(sku, intl, id, defaultMessage) {
  if (!sku || !id) {
    return defaultMessage;
  }
  return intl.formatMessage({ id, defaultMessage });
}

export const handleRedirect = (banner, navigate, path) => {
  const { redirectLink, isExternal } = banner[0] || {};
  const hasRedirectLink = redirectLink && redirectLink !== "";

  if (hasRedirectLink) {
    if (isExternal) {
      window.open(redirectLink, "_blank");
    } else {
      navigate(redirectLink);
    }
  } else if (path) {
    navigate(`${path}`);
  }
};

export const sortBlocksByReferenceOrder = (blocks, referenceList) => {
  const orderMap = Object.fromEntries(
    referenceList.map((item) => [item.id, item.order])
  );
  return [...blocks]
    .map((block) => ({
      ...block,
      referenceOrder: orderMap[block.referenceId] ?? Infinity,
    }))
    .sort((a, b) => a.referenceOrder - b.referenceOrder);
};

export const getLandingPageSku = (shop, sku) => {
  const sections = get(shop, SECTION_PATH, []);
  return sections.find((section) => section.sectionType === sku);
};

export const filterByProductsOrder = (products, productsOrder) =>
  products
    .filter(({ id, status }) => status !== "OFF" && productsOrder?.includes(id))
    .sort(sortByProductsOrder(productsOrder));

export const parseWithCustomStyles = (html, strongSpanStyle) =>
  parse(html, {
    replace: (domNode) => {
      if (domNode.name === "strong") {
        return (
          <span style={strongSpanStyle}>
            {domNode.children?.map((child, idx) =>
              child.type === "text"
                ? child.data
                : parse(child)
            )}
          </span>
        );
      }
    },
  });
